import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage    from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ConfirmPage  from './pages/ConfirmPage';
import ForgotPage   from './pages/ForgotPage';
import CallbackPage from './pages/CallbackPage';
import DashboardPage   from './pages/DashboardPage';
import NotesFormPage   from './pages/NotesFormPage';
import AdminPage       from './pages/AdminPage';
import './App.css';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, fontFamily: 'sans-serif', maxWidth: 600, margin: '60px auto' }}>
          <h2 style={{ color: '#c0392b' }}>Something went wrong</h2>
          <p style={{ color: '#555', marginBottom: 16 }}>
            {this.state.error.message || 'An unexpected error occurred.'}
          </p>
          <button onClick={() => window.location.replace('/login')}
            style={{ padding: '10px 20px', background: '#1a2b4a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
            Return to Login
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"/></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !user.isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"/></div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          {/* /callback is always accessible — handles the Cognito hosted UI redirect */}
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/login"    element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
          <Route path="/confirm"  element={<PublicRoute><ConfirmPage /></PublicRoute>} />
          <Route path="/forgot"   element={<PublicRoute><ForgotPage /></PublicRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/notes/new" element={<ProtectedRoute><NotesFormPage /></ProtectedRoute>} />
          <Route path="/notes/:id" element={<ProtectedRoute><NotesFormPage /></ProtectedRoute>} />
          <Route path="/admin"     element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ErrorBoundary>
  );
}
